import React, { FC } from 'react';
import { Image } from '../../../components/Image';
import styles from './AIApplicationList.module.scss';

interface Props {
  /** 卡片图标 */
  icon: string;
  /** 卡片标题 */
  title: string;
  /** 卡片副标题 */
  subTitle: string;
  /** 卡片描述 */
  description: string;
  /** 大屏下鼠标悬浮展示的完整图片 */
  hoverImg?: string;
}

/**
 * AI 应用生活卡片组件
 * 展示单个 AI 应用场景的图标、标题、副标题及描述
 * 大屏环境下鼠标悬浮时，切换为展示一整张图片，并带有过渡动画
 */
const AICard: FC<Props> = (props) => {
  const { icon, title, subTitle, description, hoverImg } = props;

  return (
    <div className={styles['ai-card']}>
      <div className={styles['ai-card-header']}>
        <div className={styles['ai-card-icon']}>
          <Image src={icon} layout="fill" objectFit="contain" alt={title} />
        </div>
        <h3 className={styles['ai-card-title']}>{title}</h3>
      </div>
      <div className={styles['ai-card-sub-title']}>{subTitle}</div>
      <div className={styles['ai-card-divider']} />
      <div className={styles['ai-card-description']}>{description}</div>

      {/* 大屏悬浮态展示的完整图片 */}
      {hoverImg && (
        <div className={styles['ai-card-hover-img']}>
          <Image src={hoverImg} layout="fill" objectFit="cover" alt={title} />
        </div>
      )}
    </div>
  );
};

AICard.displayName = 'AICard';
export default AICard;
